export default "__VITE_ASSET___e_vtFsP__"